/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const horizontalNavTokens = {
  CoreSpacingVertical: '8px',
  CoreSpacingHorizontal: '4px',
  CoreSpacingSide: '20px',
  CoreGapHorizontal: '32px',
  CoreColorBorderHover: '#394040',
  CoreColorBorderFocus: '#285da3',
  CoreColorBorderActive: '#235291',
  CoreColorBorderSelected: '#1c2222',
  CoreColorDivider: '#dedfdf',
  CoreFontSize: '14px',
  CoreFontWeightInitial: '400',
  CoreFontWeightSelected: '600',
  CoreFontColorInitial: '#1c2222',
  CoreFontColorHover: '#1c2222',
  CoreFontColorFocus: '#285da3',
  CoreFontColorActive: '#235291',
  CoreFontColorSelected: '#1c2222',
  CoreBorderSize: '3px',
  CoreOutlineOffset: '2px',
  CoreOutlineStroke: '2px solid',
  CoreOutlineColor: '#285da3',
} as const;
